import axios from "axios";
const ZOHO = window.ZOHO;

export const getConfigFromDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingId,
}) => {
  try {
    let reqOptions = {
      url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings/${settingId}`,
      method: "GET",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: process.env.REACT_APP_EXTENSION_IDENTIFIER,
      },
    };
    const settingResp = await axios(reqOptions);
    return { data: settingResp?.data, error: null };
  } catch (saveConfigToDBError) {
    // return { error: error?.response?.statusText,data:null };
    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const getConfigFromDB_2 = async ({
  moduleApiName = "",
  settingType = "",
  orgId,
  apiKey,
  dataCenterUrl,
  settingId,
}) => {
  const setting_url = `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`;

  let params = {};

  if (moduleApiName !== "") {
    params["moduleApiName"] = moduleApiName;
  }

  if (settingType !== "") {
    params["settingType"] = settingType;
  }

  let settingApiUrl = settingId
    ? `${setting_url}/${settingId}`
    : `${setting_url}`;

  try {
    let reqOptions = {
      url: settingApiUrl,
      method: "GET",
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: process.env.REACT_APP_EXTENSION_IDENTIFIER,
      },
      params,
    };
    const settingResp = await axios(reqOptions);
    return { data: settingResp?.data?.data, error: null };
  } catch (saveConfigToDBError) {
    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const upsertConfigToDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingType,
  moduleApiName,
  settingId,
  settingSchema,
}) => {
  try {
    let reqOptions = {
      url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`,
      method: "POST",
      data: {
        moduleApiName,
        settingId,
        settingSchema,
        settingType,
      },
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: process.env.REACT_APP_EXTENSION_IDENTIFIER,
      },
    };
    const folderResp = await axios(reqOptions);

    return { data: folderResp?.data, error: null };
  } catch (saveConfigToDBError) {
    // return { error: error?.response?.statusText };
    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const deleteConfigFromDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingId,
}) => {
  try {
    let reqOptions = {
      url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings/${settingId}`,
      method: "DELETE",
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: process.env.REACT_APP_EXTENSION_IDENTIFIER,
      },
    };
    const folderResp = await axios(reqOptions);

    return { data: folderResp?.data, error: null };
  } catch (deleteConfigFromDBError) {

    // return { error: error?.response?.statusText };
    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const saveConfigToZoho = async ({
  orgId,
  dataCenterUrl,
  settingType,
  moduleApiName,
  settingId,
}) => {
  try {
    const data = {
      connname: process.env.REACT_APP_EXTENSION_IDENTIFIER,
      orgid: orgId,
      datacenterurl: dataCenterUrl,
      settingType,
      moduleApiName,
      settingId,
    };
    const resp = await ZOHO.CRM.ACTION.setConfig(data);

    return {
      data: resp,
      error: null,
    };
  } catch (saveConfigToZohoError) {

    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const config = {
  getConfigFromDB,
  getConfigFromDB_2,
  saveConfigToZoho,
  upsertConfigToDB,
  deleteConfigFromDB,
};
